import { render, staticRenderFns } from "./studentMoviment.vue?vue&type=template&id=1f08b7a2&"
import script from "./studentMoviment.js?vue&type=script&lang=js&"
export * from "./studentMoviment.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports